import type { Control, FieldValues, Path } from "react-hook-form";

import {
  FormControl,
  FormDescription,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form";
import { Input } from "@/components/ui/input";

interface TrialDateFormValues extends FieldValues {
  trial_start_date: string;
  trial_end_date: string;
}

interface TrialDateFieldsProps<T extends TrialDateFormValues> {
  control: Control<T>;
}

export function TrialDateFields<T extends TrialDateFormValues>({
  control,
}: TrialDateFieldsProps<T>) {
  return (
    <div className="space-y-2">
      <div className="grid grid-cols-2 items-start gap-4">
        <FormField
          control={control}
          name={"trial_start_date" as Path<T>}
          // The cross-field error sits on the end date; re-check it when the
          // start date changes, so fixing the start clears it.
          rules={{ deps: "trial_end_date" as Path<T> }}
          render={({ field }) => (
            <FormItem>
              <FormLabel>Trial start date</FormLabel>
              <FormControl>
                <Input type="date" {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
        <FormField
          control={control}
          name={"trial_end_date" as Path<T>}
          render={({ field }) => (
            <FormItem>
              <FormLabel>Trial end date</FormLabel>
              <FormControl>
                <Input type="date" {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
      </div>
      <FormDescription>
        The trial ends at midnight at the end of the end date, in the
        tenant&apos;s timezone. Leave both empty for no trial.
      </FormDescription>
    </div>
  );
}
